import { Image } from "antd";
import { ChatBot } from "assets/images";
import { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import ChatIcon from 'assets/svg/chat-icon.svg';
import useChatErpUnreadSync from "views/app-views/chat-erp/useChatErpUnreadSync";

const CHAT_ERP_PATH = `${APP_PREFIX_PATH}/chat-erp`;


// Nut AI Assistant noi: bam de mo rail chat (xem ChatLauncher). Nut luon mounted du dang an,
// vi no giu useChatErpUnreadSync - unmount se ngat socket dem tin chua doc.
const FloatingChatButton = ({ isHidden, onOpen }) => {
  const { profile } = useSelector((state) => state.auth);
  useChatErpUnreadSync();
  const chatUnreadTotal = useSelector((state) => state.chatErpUnread.total);
  const location = useLocation();
  const { pathname } = location;

  const btnRef = useRef(null);
  const offsetRef = useRef({ x: 0, y: 0 });
  const movedRef = useRef(false);

  const [dragging, setDragging] = useState(false);
  const [position, setPosition] = useState({ right: 20, bottom: 80 });
  const [size, setSize] = useState(60);
  const [margin, setMargin] = useState(40);

  // ✅ Cập nhật kích thước nút chat theo màn hình
  const updateSizes = () => {
    const width = window.innerWidth;

    if (width < 768) {
      setSize(40);
      setMargin(16);
    } else if (width < 1200) {
      setSize(48);
      setMargin(24);
    } else {
      setSize(48);
      setMargin(32);
    }

    // Clamp vị trí nút chat nếu thay đổi size
    setPosition((prev) => ({
      right: Math.min(prev.right, width - size - margin),
      bottom: Math.min(prev.bottom, window.innerHeight - size - margin),
    }));
  };

  useEffect(() => {
    updateSizes();
    window.addEventListener("resize", updateSizes);
    return () => window.removeEventListener("resize", updateSizes);
  }, []);

  const getPoint = (e) => (e.touches ? e.touches[0] : e);

  const startDrag = (e) => {
    e.preventDefault();
    setDragging(true);
    movedRef.current = false;

    const point = getPoint(e);
    const rect = btnRef.current.getBoundingClientRect();

    offsetRef.current = {
      x: point.clientX - rect.left,
      y: point.clientY - rect.top,
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("mouseup", stopDrag);
    window.addEventListener("touchend", stopDrag);
  };

  const onMove = (e) => {
    e.preventDefault();
    movedRef.current = true;

    const point = getPoint(e);

    const right =
      window.innerWidth - (point.clientX - offsetRef.current.x) - size;
    const bottom =
      window.innerHeight - (point.clientY - offsetRef.current.y) - size;

    setPosition({
      right: Math.max(0, Math.min(right, window.innerWidth - size)),
      bottom: Math.max(0, Math.min(bottom, window.innerHeight - size)),
    });
  };

  const stopDrag = () => {
    setDragging(false);

    window.removeEventListener("mousemove", onMove);
    window.removeEventListener("touchmove", onMove);
    window.removeEventListener("mouseup", stopDrag);
    window.removeEventListener("touchend", stopDrag);

    // Snap sang phải + clamp dọc
    setPosition((prev) => ({
      right: margin,
      bottom: Math.min(
        Math.max(prev.bottom, margin),
        window.innerHeight - size - margin
      ),
    }));

    setTimeout(() => {
      movedRef.current = false;
    }, 0);
  };

  const handleClick = (e) => {
    if (movedRef.current) {
      e.preventDefault();
      return;
    }
    onOpen();
  };

  if (isHidden || !profile || pathname.startsWith(CHAT_ERP_PATH)) return null;

  return (
    <div
      style={{
        position: "fixed",
        right: position.right,
        bottom: position.bottom,
        width: size,
        height: size,
        // Cùng thang với vỏ chat (xem bảng z-index đầu chat-erp/override.css):
        // phải nằm dưới lớp modal của antd (1000) để không che modal ERP.
        zIndex: "var(--erp-chat-shell-z, 950)",
        transition: dragging ? "none" : "right 0.3s ease",
      }}
    >
      <button
        ref={btnRef}
        onMouseDown={startDrag}
        onTouchStart={startDrag}
        onClick={handleClick}
        title="Meditech Chat"
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          border: "none",
          background: "#22c55e",
          cursor: dragging ? "grabbing" : "grab",
          transition: "box-shadow 0.2s ease",
          touchAction: "none",
          padding: 0,
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: dragging
            ? "0 8px 20px rgba(0, 0, 0, 0.28)"
            : "0 4px 12px rgba(0, 0, 0, 0.18)",
        }}
      >
        <Image
          src={ChatIcon}
          preview={false}
          draggable={false}
          width={size * 0.6}
          height={size * 0.6}
          style={{ objectFit: "contain" }}
        />
      </button>
      {chatUnreadTotal > 0 && (
        <span
          style={{
            position: "absolute",
            top: -2,
            right: -2,
            minWidth: 18,
            height: 18,
            padding: "0 4px",
            borderRadius: 999,
            background: "#ff4d4f",
            color: "#fff",
            fontSize: 11,
            lineHeight: "18px",
            textAlign: "center",
            fontWeight: 600,
            boxShadow: "0 0 0 2px #fff",
            pointerEvents: "none",
          }}
        >
          {chatUnreadTotal > 9 ? "9+" : chatUnreadTotal}
        </span>
      )}
    </div>
  );
};

export default FloatingChatButton;
